import { TypeEnum } from 'libs/shared-models/masters/src/lib/enums/stock-item-category-status.enum';
import { Column, CreateDateColumn, Entity, PrimaryGeneratedColumn, UpdateDateColumn, } from 'typeorm';

@Entity('stock_item_categories_log')
export class StockItemLogEntity {
    @PrimaryGeneratedColumn('increment', { name: 'id' })
    id: number;


    @Column('int', {
        name: 'stock_item_category_id',
        nullable: false,
    })
    stockItemCategoryId: number;
    @Column('varchar', {
        nullable: false,
        // length: 30,
        name: 'category',
    })
    category: string;


    @Column({
        type: 'enum',
        enum: TypeEnum,
        nullable: false,
        name: 'type'
    })
    type: string;

    @CreateDateColumn({
        name: 'created_at',
        type: 'datetime',
    })
    createdAt: Date;

    @UpdateDateColumn({
        name: "updated_at",
        type: 'datetime'
    })
    updatedAt: Date;


    @Column('varchar', {
        nullable: true,
        name: 'updated_user',
        length: 50,
    })
    updatedUser: string | null;

    @Column('varchar', {
        nullable: true,
        name: 'created_user',
        length: 50,
    })
    createdUser: string | null;





}


